import { FilterViewModelDiscriminator, type ProductListResultViewModel } from 'autogen/swagger/all';
import BooleanFilterOption from '../BooleanFilter/BooleanFilterOption';
import RootBrandFilterMenuItem from './RootBrandFilterMenuItem';
import RootDefaultFilterMenuItem from './RootDefaultFilterMenuItem';
import RootPriceFilterMenuItem from './RootPriceFilterMenuItem';

export default function RootFilterMenuItem({ model }: { model: ProductListResultViewModel['filters'][0] }) {
    const { displayName, queryStringName } = model;

    return FilterViewModelDiscriminator(
        model,
        (priceModel) => <RootPriceFilterMenuItem model={priceModel} />,
        (brandModel) => <RootBrandFilterMenuItem model={brandModel} />,
        (boolModel) => {
            // if the list of options only has one option and the display name is the same as the Menuitem's display name, it is considered a oneOf
            const shouldDisplayAsOneOf =
                boolModel.options.length === 1 && boolModel.options[0].displayName === displayName;

            if (shouldDisplayAsOneOf) {
                return (
                    <BooleanFilterOption
                        model={boolModel.options[0]}
                        queryStringName={queryStringName}
                        menuDisplayName={displayName}
                    />
                );
            }

            return <RootDefaultFilterMenuItem model={boolModel} />;
        },
        (boolStarModel) => <RootDefaultFilterMenuItem model={boolStarModel} />,
        () => null, // range filter not used curr,
        (colorModel) => <RootDefaultFilterMenuItem model={colorModel} />,
        (linkModel) => <RootDefaultFilterMenuItem model={linkModel} />,
        () => null
    );
}
